module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-72x72-e7d41a049d76d8c8aee94614749c6d23.png";